module.exports = __webpack_public_path__ + "static/apple-touch-icon-144x144-b304a5bbdb003410f0132b70113f9095.png";